<template>
	<div class="nav-container w-100">
		<nav class="dt w-100 border-box pa3 pl5-l pr0-l topnav" id="topnav">
			<div @click="toggleMenu" id="hd" class="w-50 v-mid dtc f3 fw3 v-mid tl mb2 mb0-l">
				<router-link to="/" id="hd" class="hd link dim " href="#" title="Home">
					Hayman Development
				</router-link>
			</div>
			<div class="fw3 dtc w-50 v-mid tc">
				<router-link to="/about" class="link dim f6 f5-l dib ph3 ph4-l" title="About">About</router-link>
				<router-link to="/portfolio" class="link dim f6 f5-l dib ph3 ph4-l" title="Portfolio">Portfolio</router-link>
				<router-link to="/press" class="link dim f6 f5-l dib ph3 ph4-l" title="Press">Press</router-link>
				<router-link to="/contact" class="link dim f6 f5-l dib ph3 ph4-l" title="Contact">Contact</router-link>
				<div class="icon container pa3" v-on:click="toggleMenu">
					<div class="bar bar1"></div>
					<div class="bar bar2"></div>
					<div class="bar bar3"></div>
				</div>
			</div>
		</nav>
		<transition name="fade">
			<div @click="toggleMenu" v-if="showMenu" class="small-menu fw3 dt h-100 w-100 v-mid tc f4">
				<router-link to="/about" class="w-100 link db dim pa4" title="About">About</router-link>
				<router-link to="/portfolio" class="w-100 link db dim pa4" title="Portfolio">Portfolio</router-link>
				<router-link to="/press" class="w-100 link db dim pa4" title="Press">Press</router-link>
				<router-link to="/contact" class="w-100 link db dim pa4" title="Contact">Contact</router-link>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'NavBar',
	data () {
		return {
			showMenu: false
		}
	},
	methods: {
		/* Toggle between adding and removing the "responsive" class to topnav when the user clicks on the icon */
		toggleMenu: function (event) {
			if (event.target.id !== 'hd' || this.showMenu && event.target.id === 'hd') {
				this.showMenu = !this.showMenu
				$('.icon').toggleClass('change')
			}
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav-container {
	position: fixed;
	z-index: 3;
  	background: #313d4a;
  	border-bottom: solid 1px;
}
.small-menu {
	position: fixed;
	height: auto;
	z-index: 2;
	background: #414d5a;
	border-top: 1px solid white;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.topnav .icon {
	display: none;
}

.bar1, .bar2, .bar3 {
	width: 25px;
	height: 1px;
	background-color: white;
	margin: 6px 0;
	transition: 0.4s;
}

.container {
	display: inline-block;
	cursor: pointer;
}

.change .bar1 {
	-webkit-transform: rotate(-45deg) translate(-9px, 6px);
	transform: rotate(-45deg) translate(-2px, 3px);
}

.change .bar2 {opacity: 0;}

.change .bar3 {
	-webkit-transform: rotate(45deg) translate(-8px, -8px);
	transform: rotate(45deg) translate(-7px, -8px);
}

@media screen and (max-width: 960px) {
	.topnav a:not(.hd) {display: none;}
	.topnav .icon {
		float: right;
		display: block;
	}
	.topnav.responsive {position: relative;}
	.topnav.responsive .icon {
		position: absolute;
		right: 0;
		top: 0;
	}
	.topnav.responsive {
		float: none;
		display: block;
		text-align: left;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue